import React from 'react';
import { ManageDispatchAreasModal } from '../../dispatch-areas/manage-dispatch-areas/manage-dispatch-areas-modal';
import { ManageEventMergeModal } from '../../merge-events/components/manage-event-merge/components/manage-event-merge-modal';
import { UnitTimersResetToModal } from '../../unit-timers/unit-timers-reset-to-modal';
import {
    useFullscreenModalControls,
    useFullscreenModalState,
} from '../context/modal-context-provider';
import { ModalComponents } from '../types';
import { CopyCallModal } from '../../copy-call/components/copy-call-modal';
import { SendDispatchAreasModal } from '../../dispatch-areas/send-dispatch-areas/send-dispatch-areas-modal';
import { ModalProps, ModalsRenderer } from '@cad-arc';
import { ErrorBoundary } from '../../monitoring/error-boundary';
import { SubmitErrorReportModal } from '../../layout/components/submit-error-report-modal';
import { ShortcutKeysModal } from '../../shortcut-keys/shortcut-keys-modal';
import { PreferencesModal } from '../../preferences/preferences-modal';
import { SaveWorkspaceAsModal } from '../../workspace-management/save-workspace-as-modal';
import { ManageDepartmentWorkspacesModal } from '../../workspace-management/manage-department-workspaces-modal';
import { ManageUserWorkspacesModal } from '../../workspace-management/manage-user-workspaces-modal';
import { AssociateEventModal } from '../../associate-event/components/associate-event-modal';
import { ScheduleEventModal } from '../../event-panel/schedule-event-modal';
import { TransferEventInfoModal } from '../../event-panel/transfer-event-info-modal';
import { RequestAssistanceModal } from '../../request-assistance/components/request-assistance-modal';
import { ResetUserWorkspaceModal } from '../../workspace-management/reset-user-workspace-modal';
import { IncomingAssignmentModal } from '../../fr-event-modals/incoming-assignment-modal';
import { SelectHeldEventModal } from '../../fr-event-modals/select-held-event-modal';
import { UnitSelfAssignmentModal } from '../../fr-event-modals/unit-self-assignment-modal';
import { AssociateBoloModal } from '../../bolos/associate-bolo/assoicate-bolo-modal';
import { UnitEmergencyCancelModal } from '../../unit-emergency/unit-emergency-cancel-modal';
import { EndUnitEmergencyModal } from '../../unit-emergency/end-unit-emergency-modal';
import { FrUnitShowCurrentLocationModal } from '../../fr-unit-show-current-location-modal/fr-unit-show-current-location-modal';
import { ShareSavedSearchModal } from '../../search-windows/share-saved-search-modal';
import { GenerateLogModal } from '../../search-windows/generate-log-modal';
import { SessionTimeoutModal } from '../../session-timeout/session-timeout-modal';
import FireStationInfoModal from '../../fire-station-info/fire-station-info-modal';

const modalComponents: ModalComponents = {
    MANAGE_EVENT_MERGE: ManageEventMergeModal,
    UNIT_TIMERS_RESET_TO: UnitTimersResetToModal,
    COPY_CALL: CopyCallModal,
    MANAGE_DISPATCH_AREAS: ManageDispatchAreasModal,
    SEND_DISPATCH_AREA: SendDispatchAreasModal,
    SUBMIT_ERROR_REPORT: SubmitErrorReportModal,
    SHORTCUT_KEYS: ShortcutKeysModal,
    PREFERENCES: PreferencesModal,
    SAVE_WORKSPACE_AS: SaveWorkspaceAsModal,
    MANAGE_DEPARTMENT_WORKSPACES_MODAL: ManageDepartmentWorkspacesModal,
    MANAGE_USER_WORKSPACES_MODAL: ManageUserWorkspacesModal,
    RESET_USER_WORKSPACE_MODAL: ResetUserWorkspaceModal,
    ASSOCIATE_EVENT: AssociateEventModal,
    SCHEDULE_EVENT: ScheduleEventModal,
    TRANSFER_EVENT_INFO: TransferEventInfoModal,
    REQUEST_ASSISTANCE: RequestAssistanceModal,
    INCOMING_ASSIGNMENT: IncomingAssignmentModal,
    SELECT_HELD_EVENT_MODAL: SelectHeldEventModal,
    UNIT_SELF_ASSIGNMENT_MODAL: UnitSelfAssignmentModal,
    ASSOCIATE_BOLO: AssociateBoloModal,
    CANCEL_UNIT_EMERGENCY_ALERT: UnitEmergencyCancelModal,
    END_UNIT_EMERGENCY_MODAL: EndUnitEmergencyModal,
    SHARE_SAVED_SEARCH_MODAL: ShareSavedSearchModal,
    SHOW_UNIT_CURRENT_LOCATION: FrUnitShowCurrentLocationModal,
    GENERATE_LOG_MODAL: GenerateLogModal,
    SESSION_TIMEOUT_MODAL: SessionTimeoutModal,
    FIRE_STATION_INFO_MODAL: FireStationInfoModal,
};

export const Modals: React.FC<{ portalProps?: ModalProps['portalProps'] }> = ({ portalProps }) => {
    const modalState = useFullscreenModalState();
    const modalControls = useFullscreenModalControls();

    if (modalState === undefined) {
        return (
            <ErrorBoundary name="FACTORY_MODAL" messageVerbNoun="opening a panel" asToast={true}>
                <ModalsRenderer />
            </ErrorBoundary>
        );
    }

    const ComponentType = modalComponents[modalState.type];

    return (
        <ErrorBoundary
            name="MODAL"
            messageVerbNoun="opening a panel"
            extraTags={{ modalType: modalState.type }}
            asToast={true}
            onError={() => {
                modalControls.close();
            }}
        >
            {/* @ts-expect-error not sure why this is needed */}
            <ComponentType {...modalState.props} portalProps={portalProps} />;
            <ModalsRenderer />
        </ErrorBoundary>
    );
};
